import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Field, change } from "redux-form";

import { CustomInput } from "components";
import { taxIdNormalizer } from "validators";
import {
	maxLengthTaxId,
	minLengthTaxId,
	required,
} from "validators/validation";

import InlineEditableField from "./inlineEditableField";

import styles from "../../merchantInfo.module.scss";

const FORM_NAME = "merchantForm";

let TaxIdFieldForm = ({
	label,
	nameField,
	initialValue,
	isLoading,
	onSubmit,
	isEditable,
}) => {
	const dispatch = useDispatch();

	const setInitialValue = useCallback(
		() => dispatch(change(FORM_NAME, nameField, initialValue)),
		[dispatch, initialValue, nameField],
	);

	useEffect(() => {
		setInitialValue();
	}, [setInitialValue]);

	return (
		<InlineEditableField
			label={label}
			value={initialValue}
			loading={isLoading}
			submitForm={onSubmit}
			onEditCancel={setInitialValue}
			isEditable={isEditable}
			component={
				<Field
					component={CustomInput}
					validate={[required, minLengthTaxId, maxLengthTaxId]}
					normalize={taxIdNormalizer}
					smSelect={12}
					name={nameField}
					loading={isLoading}
					blurLoading={isLoading}
					wrapperClassName={styles.wrapperEditField}
					wrapperCustomInput={styles.wrapperCustomInput}
				/>
			}
		/>
	);
};

export default TaxIdFieldForm;
